export default "__VITE_ASSET__623c0b2d__"